/**
 * Branch list view component (table-like)
 */
import { Branch } from '@/types';

interface BranchListViewProps {
  branches: Branch[];
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

export function BranchListView({ branches, onEdit, onDelete }: BranchListViewProps) {
  return (
    <div className="bg-surface shadow-md rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-hairline">
          <thead className="bg-surface-2">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-ink-subtle uppercase tracking-wider">
                Foto
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-ink-subtle uppercase tracking-wider">
                Nombre
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-ink-subtle uppercase tracking-wider">
                Ubicación
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-ink-subtle uppercase tracking-wider">
                Contacto
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-ink-subtle uppercase tracking-wider">
                Estado
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-ink-subtle uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-surface divide-y divide-hairline">
            {branches.map((branch) => (
              <tr key={branch.branchId} className="hover:bg-surface-2 transition-colors">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    {branch.photo ? (
                      <img
                        src={branch.photo}
                        alt={branch.name}
                        className="h-12 w-12 rounded-lg object-cover"
                      />
                    ) : (
                      <div className="h-12 w-12 rounded-lg flex items-center justify-center">
                        <span className="text-2xl">📍</span>
                      </div>
                    )}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-ink">{branch.name}</div>
                </td>
                <td className="px-6 py-4">
                  <div className="text-sm text-ink">{branch.address}</div>
                  <div className="text-sm text-ink-subtle">{branch.city}, {branch.postalCode}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-ink">{branch.email}</div>
                  <div className="text-sm text-ink-subtle">{branch.phone}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                    branch.isActive
                      ? 'bg-success/10 text-success'
                      : 'bg-danger/10 text-danger'
                  }`}>
                    {branch.isActive ? 'Activa' : 'Inactiva'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <button
                    onClick={() => onEdit(branch.branchId)}
                    className="text-info hover:text-info mr-4"
                  >
                    ✏️ Editar
                  </button>
                  <button
                    onClick={() => onDelete(branch.branchId)}
                    className="text-danger hover:text-danger"
                  >
                    🗑️ Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
